import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import PopupSelect from 'components/common/PopupSelect'
import TagList from './TagList'

const TagPopupSelect = ({ category, filters, setFilters }) => {
  const selected = category?.tags?.find((tag) =>
    filters?.find((filterUrlId) => filterUrlId === tag.urlId)
  )

  const onFilterChange = (filters) => {
    setFilters(filters)
  }

  return (
    <PopupSelect
      placeholder={category?.name}
      selectedText={selected?.name}
      modalContent={
        <>
          <Typography>
            <Box fontWeight="fontWeightBold" pb={6}>
              {category.name}
            </Box>
          </Typography>

          <TagList
            category={category}
            filters={filters}
            onChange={onFilterChange}
            defaultCollapse={false}
          />
        </>
      }
    />
  )
}

export default TagPopupSelect
